import {useState, useContext} from 'react';
import {AxiosContext} from 'components/utils/AxiosProvider';

const usePutEndpoint = endpoint => {
    const [submissionInProgress, setSubmissionInProgress] = useState(null);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const {client: axiosClient} = useContext(AxiosContext);

    const onFormPosted = result => {
        setSubmissionInProgress(false);
        error && setError(null);
        setResult(result.data);
    };

    const onError = error => {
        setSubmissionInProgress(false);
        result && setResult(null);
        setError(error.response?.data);
    };

    const put = formData => {
        setSubmissionInProgress(true);
        return axiosClient
            .put(endpoint, formData)
            .then(onFormPosted)
            .catch(onError);
    };

    const reset = () => {
        setSubmissionInProgress(null);
        setResult(null);
        setError(null);
    };

    return {
        put,
        submissionInProgress,
        result,
        error,
        reset,
    };
};

const usePutProfile = () => {
    return usePutEndpoint('/api/1/user/profile');
};

const usePutApplicationChecklist = () => {
    return usePutEndpoint('/api/1/user/application_checklist');
};

const usePutAdminTestUser = () => {
    return usePutEndpoint('/api/1/admin/testusers');
};

const usePutAdminGet719bPdf = () => {
    return usePutEndpoint('/api/1/admin/user/get_cg719b_pdf');
};

const usePutForm = endpoint => {
    return usePutEndpoint(endpoint);
};

const usePutApplication = id => {
    return usePutEndpoint(`/api/1/admin/application/${id}`);
};

const usePutApplicationPayment = id => {
    return usePutEndpoint(`/api/1/admin/application/${id}/payment`);
};

const usePutSortedUserDocuments = () => {
    return usePutEndpoint('/api/1/admin/user/get_user_document_pdf');
}

export default usePutEndpoint;
export {
    usePutProfile,
    usePutApplicationChecklist,
    usePutAdminTestUser,
    usePutAdminGet719bPdf,
    usePutForm,
    usePutApplication,
    usePutApplicationPayment,
    usePutSortedUserDocuments,
};
